import { render, staticRenderFns } from "./notesModal.vue?vue&type=template&id=5536aacc"
import script from "./notesModal.js?vue&type=script&lang=js&external"
export * from "./notesModal.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports